import fetch from 'cross-fetch'
import * as firebase from 'firebase'
require('firebase/firestore')

export const SWITCH_AUTH_STATUS = 'SWITCH_AUTH_STATUS'
export const HANDLE_MENU = 'HANDLE_MENU'
export const HANDLE_CLOSE = 'HANDLE_CLOSE'
export const SELECT_CATEGORY = 'SELECT_CATEGORY'
export const SELECT_LOCATION = 'SELECT_LOCATION'
export const REQUEST_POSTS = 'REQUEST_POSTS'
export const RECEIVE_POSTS = 'RECEIVE_POSTS'
export const REQUEST_PROFILE = 'REQUEST_PROFILE'
export const RECEIVE_PROFILE = 'RECEIVE_PROFILE'
export const TOGGLE_NAV_DRAWER = 'TOGGLE_NAV_DRAWER'
export const TOGGLE_LOGIN_DIALOG = 'TOGGLE_LOGIN_DIALOG'
export const SET_USER = 'SET_USER'

export const switchAuthStatus = checked => ({
    type: SWITCH_AUTH_STATUS,
    checked
})

export const handleMenu = event => ({
    type: HANDLE_MENU,
    anchorEl: event.currentTarget
})

export const handleClose = () => ({
    type: HANDLE_CLOSE,
    anchorEl: null
})

const selectCategory = selectedCategory => ({
    type: SELECT_CATEGORY,
    selectedCategory
})

export const selectLocation = selectedLocation => ({
    type: SELECT_LOCATION,
    selectedLocation
})

export const selectCategoryAndFetchPosts = (selectedCategory, history) => dispatch => {
    dispatch(selectCategory(selectedCategory))
    dispatch(fetchPosts(selectedCategory))
    history.push('/')
}

export const fetchPosts = (selectedCategory, selectedLocation) => dispatch => {
    const firestore = firebase.firestore()

    dispatch(requestPosts())

    if (selectedCategory) {
        firestore.collection('users').where(`categories_parents.${selectedCategory}`, '==', true).orderBy('fblike', 'desc').get().then((querySnapshot) => {
            let posts = querySnapshot.docs.map(doc => doc.data())
            return dispatch(receivePosts(posts))
        }).catch(error => console.log("Error getting document:", error))
    } else {
        firestore.collection('users').orderBy('fblike', 'desc').get().then((querySnapshot) => {
            let posts = querySnapshot.docs.map(doc => doc.data())
            return dispatch(receivePosts(posts))
        }).catch(error => console.log("Error getting document:", error))
    }
}

const requestPosts = () => ({
    type: REQUEST_POSTS
})

const receivePosts = posts => ({
    type: RECEIVE_POSTS,
    posts
})

export const fetchProfile = UID => dispatch => {
    const firestore = firebase.firestore()

    dispatch(requestProfile())

    firebase.firestore().collection('users').doc(UID).get().then(doc => {
        if (doc.exists) {
            //////// test /////////
            console.log("Document data:", doc.data())
            ///////////////////////
            return dispatch(receiveProfile(doc.data()))
        } else {
            //////// test //////////
            console.log('user does not exist!!')
            ////////////////////////
        }
    }).catch(error => console.log("Error getting document:", error))
}

const requestProfile = () => ({
    type: REQUEST_PROFILE
})

const receiveProfile = profile => ({
    type: RECEIVE_PROFILE,
    profile
})

export const toggleNavDrawer = isOpen => ({
    type: TOGGLE_NAV_DRAWER,
    isOpen
})

export const toggleLoginDialog = isOpen => ({
    type: TOGGLE_LOGIN_DIALOG,
    isOpen
})

export const setUser = user => ({
    type: SET_USER,
    user
})


// WEBPACK FOOTER //
// ./src/actions/index.js